import type { FC } from 'react';
import RegistryModuleForm from './RegistryModuleForm';
import type { RegistryModuleSelection } from './RegistryModuleForm.types';
import { useActivateRegistryModuleMutation } from './CustomerLinks.queries';

interface ActivateFromRegistryFormProps {
    projectIdn?: string;
    onClose: () => void;
}

const ActivateFromRegistryForm: FC<ActivateFromRegistryFormProps> = ({
    projectIdn,
    onClose
}) => {
    const activateMutation = useActivateRegistryModuleMutation();

    const handleActivate = async (
        selection: RegistryModuleSelection
    ): Promise<void> => {
        if (!projectIdn) {
            return;
        }

        try {
            await activateMutation.mutateAsync({
                projectIdn,
                registryIdn: selection.registryIdn,
                moduleIdn: selection.moduleIdn,
                moduleVersion: selection.moduleVersion
            });
            onClose();
        } catch {
            return;
        }
    };

    return (
        <RegistryModuleForm
            allowLatestVersion
            isPending={activateMutation.isPending}
            isSubmitDisabled={!projectIdn}
            submitLabel="Activate"
            onCancel={onClose}
            onSubmit={handleActivate}
        />
    );
};

export default ActivateFromRegistryForm;
